import { Type, type SchemaOptions } from '@sinclair/typebox';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PACK_TYPE = 'PACK_TYPE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum pack_type
export enum PackType {
  CURE = 'CURE',
  FORFAIT = 'FORFAIT',
}

export const PackTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PACK_TYPE}${PackType.CURE}`]: 'Cure',
    [`${TRANSLATE_KEY_PACK_TYPE}${PackType.FORFAIT}`]: 'Forfait',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PackType, PackTypeTranslation, TRANSLATE_KEY_PACK_TYPE, true);

export const PackTypeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(PackType).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_PACK_TYPE}${value}`,
      }),
    ),
    options,
  );
};
